import moment from "moment";
import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Financial Accounts Information": [
      {
        title: "Account",
        dataIndex: "Account",
        key: "account",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Account Number",
        dataIndex: "Account Number",
        key: "accountNumber",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Current Balance",
        dataIndex: "Current Balance",
        key: "currentbalances",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Joint/Individual Status",
        dataIndex: "Joint/Individual Status",
        key: "joint/individualstatus",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Date Opened",
        dataIndex: "Date Openend",
        key: "dateOpened",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY")  : "N/A"),
      },
      {
        title: "Source Of Funds",
        dataIndex: "Source Of Funds",
        key: "sourceOfFunds",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
 
    "Real Estate Information": [
      {
        title: "Real Estate",
        dataIndex: "Real Estate",
        key: "realState",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Date Acquired",
        dataIndex: "Date Acquired",
        key: "dateAcquired",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY")  : "N/A"),
      },
      {
        title: "Purchase Price",
        dataIndex: "Purchase Price",
        key: "purchasePrice",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Current Value",
        dataIndex: "Current Value",
        key: "currentValue",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      {
        title: "Mortgage Details",
        dataIndex: "Mortgage Details",
        key: "mortgageDetails",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Title Information",
        dataIndex: "Title Information",
        key: "titleInformation",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Vehicle Information Divorce": [
      {
        title: "Vehicle",
        dataIndex: "Vehicle",
        key: "vehicle",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Joint/Individual Status",
        dataIndex: "Joint/Individual Status",
        key: "jointindividualstatus",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Current Value",
        dataIndex: "Current Value",
        key: "currentvalue",
        // render: (record) => (record ? record : "N/A"),
        render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
      },
      actionColumn,
    ],
    "Personal Property Information": [
        {
          title: "Personal Property",
          dataIndex: "Personal Property",
          key: "personalProperty",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Joint/Individual Status",
          dataIndex: "Joint/Individual Status",
          key: "jointindividualstatus",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Current Value",
          dataIndex: "Current Value",
          key: "currentvalue",
          // render: (record) => (record ? record : "N/A"),
          render: (record) => 
          record !== undefined && record !== null
          ? `$${Number(record).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
        })}`
      : "N/A",
        },
        actionColumn,
      ],
  };
};
